import React, { useRef, useState, useEffect, Component } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Divider,
  Autocomplete,
  TextField,
  // Checkbox,
  Tooltip,
  Avatar,
} from "@mui/material";
import Checkbox, { checkboxClasses } from "@mui/material/Checkbox";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import CloseIcon from "@mui/icons-material/Close";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import { postUser } from "../../services/user.service";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";
import { getProject } from "../../services/project.service";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { FileUploader } from "react-drag-drop-files";

import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import NoProfile from "../../assets/images/No_Profile.svg";
import Delete_Icon from "../../assets/images/Task_File_Delete_Icon.svg";
import { encryptData } from "../../utils/cryptoUtils";

const AddUser = (props) => {
  const { setOpenDrawer, formType, GetData, selectedData,Ismanager } = props;
  console.log("selectedData", Ismanager);
  const disabled = formType === "view";
  const formRef = useRef(null);
  const [isChecked, setIsChecked] = useState(false);
  const [projectData, setProjectData] = useState([]);
  // const [open, setOpen] = useState(false);
  const [initialValues, setInitialValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNo: "",
    employeeID: "",
    project: "",
    joiningDate: "",
    availableLeave: {
      earnedLeave: "",
    },
    password: "",
    confirmPassword: "",
    file: [],
  });
  const [fileName, setFileName] = useState(
    formType === "edit"
      ? selectedData?.file?.fileName
      : "Drag & Drop or click to upload videos"
  );

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string()
      .required("Please enter email")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Please enter a valid email address"
      )
      .test(
        "is-com",
        "Email must end with .com",
        (value) => value && value.endsWith(".com")
      ),
    mobileNo: Yup.string()
      .required("Mobile Number is required")
      .matches(
        /^[0-9]{10}$/,
        "Mobile Number must be 10 digits and contain only numbers"
      ),
    // employeeID: Yup.string().required("EmployeeID is required"),
    joiningDate: Yup.string().required("Select Joining Date"),
    // project: Yup.array()
    //   .of(Yup.string().required("Project Required *"))
    //   .required("Project Required *"),
    password: Yup.string().required("Password is required"),
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password")], "Passwords must match"),
  });
  const getProjectData = async () => {
    try {
      const res = await getProject({ isEnabled: true });
      const configData = res.data.data.map((e) => {
        return {
          ...e,
          label: e.name,
        };
      });
      setProjectData(configData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getProjectData();
    if (formType === "edit" || formType === "view") {
      setInitialValues({
        firstName: selectedData.firstName || "",
        lastName: selectedData.lastName || "",
        email: selectedData.email || "",
        mobileNo: selectedData.mobileNo || "",
        employeeID: selectedData.employeeID || "",
        // project: selectedData.project || "",
        project: Array.isArray(selectedData.project)
          ? selectedData.project.map((proj) => proj._id) // Ensure this is an array of IDs
          : [],
        joiningDate: selectedData.joiningDate || "",
        earnedLeave: selectedData.earnedLeave || "",
        password: selectedData.password || "",
        confirmPassword: selectedData.password || "",
      });
    }
  }, [formType, selectedData]);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  // const onSubmit = async (values) => {
  //   try {
  //     const apiMethod = postUser(values);
  //     const res = await apiMethod;
  //     ToastSuccess(res.message);
  //     setOpenDrawer(false);
  //     GetData();
  //   } catch (error) {
  //     ToastError(error?.data?.message);
  //   }
  // };

  const [tempImage, setTempImage] = useState(null);
  const renderFile = (file) => {
    if (tempImage) {
      return (
        <img
          src={tempImage}
          alt={fileName || "Temporary Image"}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            cursor: "pointer",
          }}
        />
      );
    }
    if (!file?.location) return <img src={NoProfile} alt="No_Profile" />;
    return (
      <img
        src={file.location}
        alt={file.fileName || "No Profile"}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          cursor: "pointer",
        }}
        // onClick={() => handleImageClick(file.location)}
      />
    );
  };

  const onSubmit = async (values) => {
    try {
      const formData = new FormData();
      const { file, ...bodyData } = values;
      const filteredBodyData = Object.fromEntries(
        Object.entries({ ...bodyData }).filter(([key, value]) => value !== "")
      );

      if (Ismanager) {
        filteredBodyData.isManager = true;
      }
      const encryptedBodyData = {};
      Object.keys(filteredBodyData).forEach((key) => {
        encryptedBodyData[key] = encryptData(filteredBodyData[key]);
      });
      // if (file && file.length) {
      //   file.forEach((file) => {
      //     formData.append("files", file);
      //   });
      // }

      if (file) {
        formData.append("files", file);
      }
      formData.append("bodyData", JSON.stringify(encryptedBodyData));

      const apiMethod = postUser(formData);
      const res = await apiMethod;
      ToastSuccess(res.message);
      setOpenDrawer(false);
      GetData();
    } catch (error) {
      ToastError(error?.data?.message);
    }
  };

  return (
    <div className={`${"addRenderingPopup"} no-scrollbar`}>
      <Box className="addContainerHeader">
        <Typography className="headerTitle">
          {formType === "edit" ? "Edit" : formType === "view" ? "View" : "Add"}{" "}
          {Ismanager ? "Manager" : "Employee"}
        </Typography>
        <CloseIcon
          className="Close-Icon"
          onClick={() => setOpenDrawer(false)}
        />
      </Box>
      <Divider sx={{ opacity: 1 }} />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={onSubmit}
        innerRef={formRef}
      >
        {({ touched, errors, setFieldValue, values }) => (
          <Form>
            <Box className="addContainerCenter" mb={1}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Grid item xs={12} sm={12} mt={2}>
                    <Typography className="inputLabel">
                      First Name <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Field
                      name="firstName"
                      className="InputField"
                      placeholder="Enter First Name"
                      disabled={disabled}
                    />
                    <div className="form-error">
                      {touched.firstName &&
                        errors.firstName &&
                        errors.firstName}
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} mt={2}>
                    <Typography className="inputLabel">
                      Last Name <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Field
                      name="lastName"
                      className="InputField"
                      placeholder="Enter Last Name"
                      disabled={disabled}
                    />
                    <div className="form-error">
                      {touched.lastName && errors.lastName && errors.lastName}
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} mt={2}>
                    <Typography className="inputLabel">
                      Email <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Field
                      name="email"
                      className="InputField"
                      placeholder="Enter Email"
                      disabled={disabled}
                    />
                    <div className="form-error">
                      {touched.email && errors.email && errors.email}
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} mt={2}>
                    <Typography className="inputLabel">
                      Mobile <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Field
                      name="mobileNo"
                      type="number"
                      className="InputField"
                      placeholder="Enter Mobile Number"
                      disabled={disabled}
                      inputProps={{
                        maxLength: 10,
                        minLength: 10,
                        sx: {
                          "&::placeholder": {
                            fontSize: "12px",
                            color: "#757575",
                            opacity: 1,
                            fontFamily: "Open Sans, sans-serif !important",
                          },
                        },
                      }}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                      }}
                    />
                    <div className="form-error">
                      {touched.mobileNo && errors.mobileNo && errors.mobileNo}
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} mt={2}>
                    <Typography className="inputLabel">
                      Joining Date <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker", "DatePicker"]}>
                        <DatePicker
                          value={
                            values?.joiningDate
                              ? dayjs(values?.joiningDate)
                              : null
                          }
                          onChange={(e) => setFieldValue("joiningDate", e.$d)}
                          className="datePicker w-100"
                          disabled={disabled}
                          format="DD/MM/YYYY"
                          // open={open}
                          // onClose={() => setOpen(false)}
                          // slotProps={{
                          //   openPickerIcon: {
                          //     component: CalendarTodayRoundedIcon,
                          //   },
                          //   textField: {
                          //     onClick: () => setOpen(true),
                          //   },
                          // }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                    <div className="form-error">
                      {touched.joiningDate &&
                        errors.joiningDate &&
                        errors.joiningDate}
                    </div>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }} mt={2}>
                    <div className="wsh-form-control">
                      <Typography className="inputLabel">Project</Typography>
                      <Autocomplete
                        options={projectData}
                        disableCloseOnSelect
                        disabled={disabled}
                        multiple
                        value={projectData.filter((option) =>
                          values.project.includes(option._id)
                        )}
                        onChange={(e, v) => {
                          // setFieldValue("project", v?._id);
                          setFieldValue(
                            "project",
                            v.map((option) => option._id)
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            focused={false}
                            placeholder="Select Project"
                            className="AutoComplete_InputBox"
                          />
                        )}
                      />
                      <div className="form-error">
                        {touched.project && errors.project && errors.project}
                      </div>
                    </div>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    mt={2}
                    sx={{
                      display: "flex",
                      // alignItems: "center",
                      // alignContent: "center",
                      justifyContent: "center",
                    }}
                  >
                    {/* <div className="wsh-form-control"> */}
                    {/* <Typography className="inputLabel">Add Profile</Typography> */}
                    {/* <FileUploader
                    handleChange={(e) => {
                      const files = e instanceof FileList ? Array.from(e) : [e];
                      setFieldValue("files", files);
                      setFileName(files.map((file) => file.name).join(", "));
                    }}
                    name="files"
                    multiple={true}
                    dropMessageStyle={{
                      color: "green",
                      border: "none",
                      borderRadius: "0px",
                    }}
                  /> */}
                    <Grid>
                      <Box
                        sx={{
                          display: "flex", // To center the content
                          justifyContent: "center", // Center avatar horizontally
                          alignItems: "center", // Center avatar vertically
                          position: "relative", // To position the delete icon properly
                        }}
                      >
                        <Avatar
                          sx={{
                            width: 90, // Set the width of the avatar
                            height: 90, // Set the height of the avatar (should match width for a circle)
                            borderRadius: "50%", // Ensure the avatar is circular
                            overflow: "hidden",
                          }}
                        >
                          {renderFile(selectedData?.file)}{" "}
                        </Avatar>
                        <Box
                          sx={{
                            position: "absolute", // Position it on top of the avatar
                            top: 0,
                            right: 0,
                            cursor: "pointer", // Make the icon clickable
                            padding: "4px", // Padding for the icon (optional)
                          }}
                        >
                          <img
                            src={Delete_Icon}
                            alt={"Delete_Icon"}
                            onClick={() => {
                              setFieldValue("file", null);
                              setTempImage(null);
                            }}
                            style={{
                              width: 20, // Set the width of the delete icon
                              height: 20, // Set the height of the delete icon
                              background: "#DBDADA",
                              borderRadius: "50%",
                              color: "red",
                              padding: 2,
                            }}
                          />
                        </Box>
                      </Box>
                    </Grid>
                    {/* <Box className="uploadIcon">
                    <CloudUploadOutlinedIcon />
                    {fileName ? (
                      <span>{fileName}</span>
                    ) : (
                      "Drag & Drop or click to upload files"
                    )}
                  </Box> */}
                    {/* <div className="form-error">
                        {touched.file && errors.file && errors.file}
                      </div>
                    </div> */}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    mt={2}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      // sx={{
                      //   color: "#fff",
                      //   // backgroundColor: tempImage ? "#008080" : "#999",
                      //   backgroundColor: "#008080",
                      //   textTransform: "none",
                      //   // width: "50% !important",
                      // }}
                      className="Add-Button-Popup"
                      component="label"
                      startIcon={<BorderColorOutlinedIcon />}
                    >
                      {formType === "add" ? "Add Photo" : "Edit Photo"}
                      <input
                        type="file"
                        hidden
                        onChange={(e) => {
                          const files = e.target.files[0];
                          if (files) {
                            // Generate a temporary URL for preview
                            const tempUrl = URL.createObjectURL(files);
                            setTempImage(tempUrl);
                            setFileName(files.name);
                            setFieldValue("file", files);
                          }
                        }}
                      />
                    </Button>
                  </Grid>

                  {formType === "add" && (
                    <>
                      <Grid item xs={12} sm={12} mt={1.5}>
                        <Typography className="inputLabel">
                          Password <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <Field
                          name="password"
                          className="InputField w-100"
                          placeholder="Enter Password"
                          disabled={disabled}
                        />
                        <div className="form-error">
                          {touched.password &&
                            errors.password &&
                            errors.password}
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12} mt={2}>
                        <Typography className="inputLabel">
                          Confirm Password{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <Field
                          name="confirmPassword"
                          className="InputField w-100"
                          placeholder="Enter Confirm Password"
                          disabled={disabled}
                        />
                        <div className="form-error">
                          {touched.confirmPassword &&
                            errors.confirmPassword &&
                            errors.confirmPassword}
                        </div>
                      </Grid>
                    </>
                  )}
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    sx={{ display: "flex", mt: 2, alignItems: "center" }}
                  >
                    <Grid>
                      <Tooltip title="Add Earned Leave">
                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          <Checkbox
                            defaultChecked={isChecked}
                            size="small"
                            onChange={handleCheckboxChange}
                            // sx={{  mt: 2.5,}}
                            sx={{
                              mt: 2.5,
                              [` &.${checkboxClasses.checked}`]: {
                                color: "#008080",
                              },
                            }}
                          />
                          {!isChecked && (
                            <Typography sx={{ mt: 2.5 }}>
                              Add Earned Leave
                            </Typography>
                          )}
                        </Box>
                      </Tooltip>
                    </Grid>
                    {isChecked && (
                      <Grid xs={12} sm={12}>
                        <Typography className="inputLabel">
                          Earned Leave Count{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <Field
                          name="availableLeave.earnedLeave"
                          className="InputField w-100"
                          placeholder="Enter Earned Leave Count"
                          disabled={disabled}
                        />
                        {/* <div className="form-error">
                      {touched.earnedLeave &&
                        errors.earnedLeave &&
                        errors.earnedLeave}
                    </div> */}
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Box>
            <Grid className="addboxFooter">
              <Button
                className="cancelButton"
                onClick={() => setOpenDrawer(false)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="saveButton"
                sx={{ display: disabled ? "none" : "flex" }}
              >
                Save
              </Button>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddUser;
